import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para restablecer la posición del scroll al cambiar de ruta
 */
export function useScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Desplazarse al inicio en cada cambio de ruta
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });

    // También es útil para accesibilidad enfocar el contenido principal
    const mainContent = document.querySelector('main');
    if (mainContent) {
      mainContent.focus();
    }
  }, [pathname]);
}
